<div class="entsorger-page">
    <div class="list-title-row">
        <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="list-title">Entsorger ({{ favoritenEntsorger?.length || 0 }})</h3>
        <span class="spacer"></span>
        <button *kienePermission="[9142]" (click)="entsorgerHinzufuegen()" color="accent" mat-icon-button class="add-button">
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div *ngIf="entsorgerFehlt" style="margin-bottom: 12px">
        <mat-hint class="hinweis-text" style="display: flex; align-items: flex-start; justify-content: flex-start">
            <div>
                <span class="dot-warn"></span>
            </div>
            <div style="text-align: justify; margin-left: 6px">
                <span> Es muss mind. ein Entsorger hinterlegt werden, sonst ist keine Todmeldung m&ouml;glich.</span>
            </div>
        </mat-hint>
    </div>

    <div class="mobile-cards" *ngIf="isMobileScreen && favoritenEntsorger?.length; else desktopOrEmpty">
        <div class="mobile-card" *ngFor="let entsorger of getSortedEntsorger()">
            <div class="mobile-card__header">
                <div class="mobile-card__title-wrap">
                    <div class="mobile-card__title">{{ entsorger.name || '-' }}</div>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="entsorgerMenuMobile" class="options-button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #entsorgerMenuMobile="matMenu" xPosition="before" yPosition="below">
                    <button mat-menu-item (click)="editiereEntsorger(entsorger)">
                        <mat-icon>edit</mat-icon>
                        <span>bearbeiten</span>
                    </button>
                    <button mat-menu-item *ngIf="entsorger.email" (click)="sendMail(entsorger)">
                        <mat-icon>mail</mat-icon>
                        <span>E-Mail senden</span>
                    </button>
                    <button mat-menu-item (click)="entsorgerEntfernen(entsorger)">
                        <mat-icon>delete</mat-icon>
                        <span>Entsorger entfernen</span>
                    </button>
                </mat-menu>
            </div>
            <div class="mobile-card__grid">
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Name</span>
                    <span class="mobile-card__value">{{ entsorger.name || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">VVVO</span>
                    <span class="mobile-card__value">{{ entsorger.vvvo || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Adresse</span>
                    <span class="mobile-card__value">{{ getAdresse(entsorger) }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">E-Mail Adresse</span>
                    <a
                        [href]="'mailto:' + entsorger.email"
                        class="mobile-card__value"
                        [class.mobile-card__value--disabled]="!entsorger.email"
                        [attr.tabindex]="entsorger.email ? null : -1"
                    >
                        {{ entsorger.email || '-' }}
                    </a>
                </div>
            </div>
        </div>
    </div>

    <ng-template #desktopOrEmpty>
        <div class="list-wrapper" *ngIf="favoritenEntsorger?.length; else noEntsorger">
            <div class="list-header">
                <button class="sort-header" type="button" (click)="setSort('name')">
                    Name
                    <mat-icon class="sort-icon" *ngIf="sortField === 'name'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('vvvo')">
                    VVVO
                    <mat-icon class="sort-icon" *ngIf="sortField === 'vvvo'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('adresse')">
                    Adresse
                    <mat-icon class="sort-icon" *ngIf="sortField === 'adresse'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('email')">
                    E-Mail Adresse
                    <mat-icon class="sort-icon" *ngIf="sortField === 'email'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <span></span>
            </div>
            <ng-container *ngFor="let entsorger of getSortedEntsorger()">
                <div class="list-row">
                    <span>
                        <span class="mobile-field-label">Name:</span>
                        <span class="mobile-field-value">{{ entsorger.name || '-' }}</span>
                    </span>
                    <span>
                        <span class="mobile-field-label">VVVO:</span>
                        <span class="mobile-field-value">{{ entsorger.vvvo || '-' }}</span>
                    </span>
                    <span>
                        <span class="mobile-field-label">Adresse:</span>
                        <span class="mobile-field-value">{{ getAdresse(entsorger) }}</span>
                    </span>
                    <span>
                        <span class="mobile-field-label">E-Mail Adresse:</span>
                        <span class="mobile-field-value">{{ entsorger.email || '-' }}</span>
                    </span>
                    <span class="row-actions">
                        <button mat-icon-button [matMenuTriggerFor]="entsorgerMenu" class="options-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #entsorgerMenu>
                            <button mat-menu-item (click)="editiereEntsorger(entsorger)">
                                <mat-icon>edit</mat-icon>
                                <span>bearbeiten</span>
                            </button>
                            <button mat-menu-item *ngIf="entsorger.email" (click)="sendMail(entsorger)">
                                <mat-icon>mail</mat-icon>
                                <span>E-Mail senden</span>
                            </button>
                            <button mat-menu-item (click)="entsorgerEntfernen(entsorger)">
                                <mat-icon>delete</mat-icon>
                                <span>Entsorger entfernen</span>
                            </button>
                        </mat-menu>
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-template>
    <ng-template #noEntsorger>
        <div class="empty-state">Keine Entsorger gefunden.</div>
    </ng-template>
</div>
